jQuery(document).ready(function() {
    
	$("#Form_ContactForm").validate({
		showErrors: function(errorMap, errorList) {
			$('div.field span.message').hide();
			$('input').removeClass('holder-required').removeClass('holder-validation');
			$('textarea').removeClass('holder-required').removeClass('holder-validation');
			$('select').removeClass('holder-required').removeClass('holder-validation');
			this.defaultShowErrors();
		},
		errorPlacement: function(error, element) {
			if (element.parents('div.fieldholder-small').length > 0) {
				error.appendTo(element.parents('div.fieldholder-small'));
			} else {
				error.appendTo(element.parents('div.field'));
			}
		},
		rules: {
            FirstName: {
				required: true
			},
			Surname: {
				required: true
			},
			Phone: {
				phoneAU: true
			},
            Email: {
				required: true,
				email: true
			},
			Message: {
				required: true
            }
		}
	});


	// jquery for filter form on locations page

	$('.filter-bar .apply').on('click', function() {
        $(this).addClass('select-active');
        $('form#productsfilter').submit();
    });

    $('.filter-bar .dropdown-pane-button.service').on('click', function() {
        $('.dropdown-pane.service').slideToggle("fast");
        $('.dropdown-pane.suburb').hide("fast");
    }); 

    $('.filter-bar .dropdown-pane-button.suburb').on('click', function() {
        $('.dropdown-pane.suburb').slideToggle("fast");
        $('.dropdown-pane.service').hide("fast");
    }); 
    
});
